<template>
  <div class="trace-health-page">
    <a-row :gutter="16" class="stats-row">
      <a-col :span="3">
        <a-card><a-statistic title="需处理" :value="issueTotal" /></a-card>
      </a-col>
      <a-col :span="3">
        <a-card><a-statistic title="未赋码" :value="stats.uncoded" /></a-card>
      </a-col>
      <a-col :span="3">
        <a-card><a-statistic title="缺投料" :value="stats.pending" /></a-card>
      </a-col>
      <a-col :span="3">
        <a-card><a-statistic title="缺检验" :value="stats.incomplete" /></a-card>
      </a-col>
      <a-col :span="3">
        <a-card><a-statistic title="数据异常" :value="stats.abnormal" /></a-card>
      </a-col>
      <a-col :span="3">
        <a-card><a-statistic title="已完整" :value="stats.complete" /></a-card>
      </a-col>
      <a-col :span="3">
        <a-card><a-statistic title="商品总数" :value="stats.total" /></a-card>
      </a-col>
      <a-col :span="3">
        <a-card><a-statistic title="完整率" :value="stats.rate" /></a-card>
      </a-col>
    </a-row>

    <a-card title="追溯体检">
      <a-form-model layout="inline" :model="searchForm" class="search-form">
        <a-form-model-item label="状态">
          <a-select v-model="searchForm.status" style="width: 140px" @change="handleSearch">
            <a-select-option value="issues">待处理</a-select-option>
            <a-select-option value="all">全部</a-select-option>
            <a-select-option value="unarchived">未建档</a-select-option>
            <a-select-option value="pending">待上传</a-select-option>
            <a-select-option value="incomplete">待完善</a-select-option>
            <a-select-option value="complete">已完整</a-select-option>
            <a-select-option value="abnormal">异常</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关键词">
          <a-input-search
            v-model="searchForm.search"
            allowClear
            placeholder="商品名称/编号/条码"
            style="width: 260px"
            @search="handleSearch"
          />
        </a-form-model-item>
      </a-form-model>

      <a-table
        rowKey="row_key"
        size="small"
        :columns="columns"
        :dataSource="items"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <template slot="status" slot-scope="text">
          <a-tag :color="statusMeta[text] ? statusMeta[text].color : 'default'">
            {{ statusMeta[text] ? statusMeta[text].label : text }}
          </a-tag>
        </template>
        <template slot="trace_product_id" slot-scope="text">
          <span>{{ text || '-' }}</span>
        </template>
        <template slot="latest_batch" slot-scope="text">
          <span>{{ text || '-' }}</span>
        </template>
        <template slot="checks" slot-scope="text, record">
          <span v-if="record.status === 'unarchived'">-</span>
          <span v-else class="check-tags">
            <a-tag :color="record.has_formula ? 'green' : 'orange'">投料</a-tag>
            <a-tag :color="record.has_report ? 'green' : 'orange'">检验</a-tag>
          </span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-button v-if="record.status === 'unarchived'" type="link" size="small" :loading="codingLoading" @click="handleCoding(record)">
            去赋码
          </a-button>
          <a-button v-else-if="record.status === 'pending'" type="link" size="small" @click="goTraceResult(record)">
            补投料
          </a-button>
          <a-button v-else-if="record.status === 'incomplete'" type="link" size="small" @click="goTraceResult(record)">
            补检验
          </a-button>
          <a-button v-else-if="record.status === 'complete'" type="link" size="small" @click="goTraceResult(record)">
            查看追溯
          </a-button>
          <a-button v-if="record.status !== 'unarchived'" type="link" size="small" @click="goTraceChain(record)">
            链路查询
          </a-button>
          <span v-else-if="record.status === 'abnormal'">-</span>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { goodsBatchCoding, traceHealthList, traceHealthStats } from '@/api/goods'

export default {
  name: 'TraceHealth',
  data() {
    return {
      loading: false,
      codingLoading: false,
      stats: {
        total: 0,
        coded: 0,
        uncoded: 0,
        pending: 0,
        incomplete: 0,
        complete: 0,
        abnormal: 0,
        rate: '0.00%',
      },
      searchForm: {
        status: 'issues',
        search: '',
        page: 1,
        page_size: 20,
      },
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`,
      },
      statusMeta: {
        unarchived: { label: '未建档', color: 'red' },
        pending: { label: '待上传', color: 'orange' },
        incomplete: { label: '待完善', color: 'gold' },
        complete: { label: '已完整', color: 'green' },
        abnormal: { label: '异常', color: 'red' },
      },
      columns: [
        { title: '问题类型', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 96 },
        { title: '商品编号', dataIndex: 'goods_number', width: 150, className: 'trace-health-nowrap' },
        { title: '商品名称', dataIndex: 'goods_name', width: 230, ellipsis: true },
        { title: '追溯产品', dataIndex: 'trace_product', width: 230, ellipsis: true },
        { title: '最新批次', dataIndex: 'latest_batch', scopedSlots: { customRender: 'latest_batch' }, width: 120 },
        { title: '缺失环节', key: 'checks', scopedSlots: { customRender: 'checks' }, width: 130 },
        { title: '诊断结论', dataIndex: 'reason', width: 260, ellipsis: true },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, width: 96 },
      ],
      items: [],
    }
  },
  computed: {
    issueTotal() {
      return (this.stats.uncoded || 0) + (this.stats.pending || 0) + (this.stats.incomplete || 0) + (this.stats.abnormal || 0)
    },
  },
  created() {
    this.loadStats()
    this.loadList()
  },
  methods: {
    async loadStats() {
      const res = await traceHealthStats()
      this.stats = { ...this.stats, ...res }
    },
    async loadList() {
      this.loading = true
      try {
        const res = await traceHealthList(this.searchForm)
        this.items = res.results || []
        this.pagination.total = res.count || 0
        this.pagination.current = this.searchForm.page
        this.pagination.pageSize = this.searchForm.page_size
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.searchForm.page = 1
      this.pagination.current = 1
      this.loadStats()
      this.loadList()
    },
    handleTableChange(pagination) {
      this.searchForm.page = pagination.current
      this.searchForm.page_size = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadList()
    },
    handleCoding(record) {
      if (!record.goods_id) {
        this.$message.warning('该行缺少商品ID，无法赋码')
        return
      }
      this.$confirm({
        title: '确认赋码',
        content: `确定为商品"${record.goods_name}"创建追溯产品记录？`,
        onOk: async () => {
          this.codingLoading = true
          try {
            const res = await goodsBatchCoding({ goods_ids: [record.goods_id] })
            this.$message.success(res.message || '赋码成功')
            await this.loadStats()
            await this.loadList()
          } catch (err) {
            this.$message.error('赋码失败：' + (err.message || '网络错误'))
          } finally {
            this.codingLoading = false
          }
        },
      })
    },
    goTraceResult(record) {
      const query = {}
      if (record.goods_id) query.product_id = String(record.goods_id)
      if (record.latest_batch) query.batch = record.latest_batch
      this.$router.push({ path: '/from/from_result', query })
    },
    goTraceChain(record) {
      const query = {}
      if (record.trace_product_id) query.product_id = String(record.trace_product_id)
      if (record.goods_id) query.goods_id = String(record.goods_id)
      if (record.latest_batch) query.batch = record.latest_batch
      if (!query.product_id && !query.goods_id) query.keyword = record.goods_name || record.goods_number
      this.$router.push({ path: '/from/trace_chain', query })
    },
  },
}
</script>

<style scoped>
.trace-health-page {
  padding: 0;
}

.stats-row {
  margin-bottom: 16px;
}

.search-form {
  margin-bottom: 16px;
}

.check-tags .ant-tag {
  margin-bottom: 4px;
}

::v-deep .trace-health-nowrap {
  white-space: nowrap;
}
</style>
